import React from "react";

const Message = () => (
  <p className="m-0 max-w-[600px] text-sm font-semibold text-slate-600">
    We grant discounts based on the circumstances of your school, including
    student numbers, type of school and other extenuating factors. This is at
    the discretion of Dr Frost staff and you will be notified when your
    application is processed.
  </p>
);

export default Message;
